var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ValidationProvider',{attrs:{"name":_vm.label,"vid":_vm.name,"rules":_vm.rules},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var errors = ref.errors;
return [_c('PasswordField',_vm._b({attrs:{"errors":errors},model:{value:(_vm.innerValue),callback:function ($$v) {_vm.innerValue=$$v},expression:"innerValue"}},'PasswordField',Object.assign({}, _vm.$attrs, _vm.$props),false))]}}])})}
var staticRenderFns = []

export { render, staticRenderFns }